'use client';
import React from 'react';
import cn from './style.module.scss';
import SpecificationTab from './SpecificationTab';
type Props = {
  anchorId?: string;
};
export default function WaldorfSpecification(props: any) {
  const {t, anchorId} = props;
  return (
    <section id={anchorId} className={cn.orientalSpecification}>
      <SpecificationTab
        t={t}
        specificationTheme={props.specificationTheme}
        specificationMobileTheme={props.specificationMobileTheme}
      />
    </section>
  );
}
